// extracted by mini-css-extract-plugin
export default {"linkCopyButton":"a4wg0","linkCopied":"miaii"};